import TinyMCEEditor from "components/UI/HTMLEditor/TinyMCEEditor";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { USER_GUIDE_TEXT } from "./UserGuide";
import { QUERY_KEYS } from "constant/react_query";
import { useSakusasEditableTextGet } from "hooks/sakusas/editable_text/useSakusasEditableTextGet";
import { useSakusasEditableTextAdd } from "hooks/sakusas/editable_text/useSakusasEditableTextAdd";
import { useSakusasEditableTextUpdate } from "hooks/sakusas/editable_text/useSakusasEditableTextUpdate";

type UserGuideEditProps = {
  cancelHandle: Function;
};

const UserGuideEdit = ({ cancelHandle }: UserGuideEditProps) => {
  const editableText = useSakusasEditableTextGet(USER_GUIDE_TEXT);
  const { editableTextAddMutate } = useSakusasEditableTextAdd({
    invalidateKeys: [QUERY_KEYS.SAKUSAS_EDITABLE_TEXT_GET, editableText.slug],
  });
  const { editableTextUpdateMutate } = useSakusasEditableTextUpdate({
    invalidateKeys: [QUERY_KEYS.SAKUSAS_EDITABLE_TEXT_GET],
  });

  const editorContentConfirm = (content: string) => {
    if (typeof editableText !== "undefined" && editableText !== null) {
      editableTextUpdateMutate({
        id: editableText.id,
        updatePayload: { content },
      });
    } else {
      editableTextAddMutate({ slug: USER_GUIDE_TEXT, content });
    }
    toast.success("Saved");
  };

  return (
    <div>
      <TinyMCEEditor
        onContentConfirm={editorContentConfirm}
        onCancel={cancelHandle}
        initialValue={editableText !== null ? editableText.content : ""}
      />
    </div>
  );
};

export default UserGuideEdit;
